import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, TextField } from "@material-ui/core";
import {
  postExperience,
  getExperience,
  delExperience,
} from "../../Services/doctor/profile";
import * as icons from "@material-ui/icons";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { useDispatch } from "react-redux";
import swal from "sweetalert";

const Experience = ({ classes }) => {
  const [experience, setExperience] = useState("");
  const [year, setYear] = useState("");
  const [expreiencies, setExperiencies] = useState([]);
  const dispatch = useDispatch();

  const handleExperience = (e) => {
    setExperience(e.target.value);
  };
  const handleYear = (e) => {
    setYear(e.target.value);
  };
  useEffect(async () => {
    dispatch(showLoading());
    try {
      {
        let { data } = await getExperience();
        data = data.data;
        setExperiencies(data);
      }
    } catch (error) {
    } finally {
      dispatch(hideLoading());
    }
  }, []);
  const handleAdd = async () => {
    try {
      dispatch(showLoading());
      let { data } = await postExperience({ name: experience, year });
      data = data.data;
      let tmp = [...expreiencies];
      tmp.push(data);
      setExperiencies(tmp);
      swal("success!", "successfully added!", "success");
    } catch (error) {
      let msg = "some error occured";
      let { status, data } = error.response;
      if (status == 400 || status == 401) {
        msg = data.msg;
      }
      swal("wrong!", msg, "error");
    } finally {
      dispatch(hideLoading());
    }
  };
  const handleDelete = async (id, name) => {
    let isSure = await swal({
      title: "Are you sure?",
      text: `Are you sure to delete ${name}!`,
      icon: "warning",
      buttons: ["No", "Yes"],
      dangerMode: true,
    });
    if (isSure) {
      dispatch(showLoading());
      try {
        await delExperience(id);
        let tmp = expreiencies.filter((item) => item._id != id);
        setExperiencies(tmp);
        swal("success!", "successfully delete!", "success");
      } catch (error) {
        let msg = "some error occured";
        let { status, data } = error.response;
        if (status == 400 || status == 401) {
          msg = data.msg;
        }
        swal("wrong!", msg, "error");
      } finally {
        dispatch(hideLoading());
      }
    }
  };
  return (
    <Container>
      <Row className="justify-content-center">
        <Col xs={12} lg={8}>
          <div className="d-flex justify-content-between">
            <span>Experience</span>
            <div>
              <Button
                onClick={handleAdd}
                variant="contained"
                className={classes.addBtn}
              >
                Add +
              </Button>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="justify-content-center mt-2">
        <Col xs={12} lg={8}>
          <Row className="mb-3">
            <Col xs={12} lg={6} className="mt-2">
              <TextField
                size="small"
                id="exName"
                fullWidth
                value={experience}
                onChange={handleExperience}
                label="Name"
                variant="outlined"
              />
            </Col>
            <Col xs={12} lg={6} className="mt-2">
              <TextField
                size="small"
                id="exYear"
                value={year}
                onChange={handleYear}
                fullWidth
                type="number"
                label="Year"
                variant="outlined"
              />
            </Col>
          </Row>
          {expreiencies.map((item) => (
            <Row key={item._id}>
              <Col xs={12} lg={6} className="mt-2">
                <TextField
                  className="mt-2"
                  size="small"
                  id="exName"
                  fullWidth
                  value={item.name}
                  onChange={handleExperience}
                  label="Name"
                  disabled
                  variant="outlined"
                />
              </Col>
              <Col xs={12} lg={5} className="mt-2">
                <TextField
                  className="mt-2"
                  disabled
                  size="small"
                  id="exYear"
                  value={item.year}
                  onChange={handleYear}
                  fullWidth
                  label="Year"
                  variant="outlined"
                />
              </Col>
              <Col xs={12} lg={1} className="mt-3">
                <Button
                  size="small"
                  fullWidth
                  onClick={() => {
                    handleDelete(item._id, item.name);
                  }}
                >
                  <icons.DeleteOutline style={{ color: "red" }} />
                </Button>
              </Col>
            </Row>
          ))}
        </Col>
      </Row>
    </Container>
  );
};

export default Experience;
